export default "__VITE_ASSET__0E_JDuGF__"